module.exports = __webpack_public_path__ + "media/images/faq/brand1-38e9dd4f7043876497778a4c7f277323.png";